import React, { FC, ReactNode } from "react";
import MinorNavbar from "../../navbar/MinorNavbar";
import MinorFooter from "../../footer/MinorFooter";

interface Props {
  children: ReactNode;
}

const MinorLayout: FC<Props> = ({ children }) => {
  return (
    <div>
      <MinorNavbar />
      <div className="page-container">{children}</div>
      <MinorFooter />
    </div>
  );
};

export default MinorLayout;
